import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors } from '../../..';
import { Typography } from '../../../theme';
import { labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { colord, extend } from 'colord';
import a11yPlugin from 'colord/plugins/a11y';
extend([a11yPlugin]);
export const Styles = labelStyles('TagLabel', {
    root: (backgroundColor, textColor) => {
        return css `
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: 30px;
      ${Typography.smallPrint1Bold};

      color: ${textColor};
      background-color: ${backgroundColor};

      &[data-size='small'] {
        height: auto;
        padding: 0 8px;
      }

      &[data-size='medium'] {
        height: auto;
        padding: 3px 8px;
      }
    `;
    },
});
const tagLabelColors = [
    'gray',
    'white',
    'info',
    'success',
    'warning',
    'error',
    'peach',
    'neutral300',
    'bolt',
    'cream',
    'success500',
    'lavender',
];
export const TagLabel = ({ children, color = 'gray', size = 'medium', className, }) => {
    let backgroundColor = Colors.neutral700;
    let textColor = Colors.neutral100;
    if (tagLabelColors.find((tagColor) => tagColor === color)) {
        switch (color) {
            case 'gray':
                backgroundColor = Colors.neutral700;
                textColor = Colors.neutral100;
                break;
            case 'white':
                backgroundColor = Colors.neutral100;
                textColor = Colors.neutral800;
                break;
            case 'info':
                backgroundColor = Colors.blue10;
                textColor = Colors.neutral800;
                break;
            case 'success':
                backgroundColor = Colors.success100;
                textColor = Colors.neutral800;
                break;
            case 'warning':
                backgroundColor = Colors.warning100;
                textColor = Colors.neutral800;
                break;
            case 'error':
                backgroundColor = Colors.error100;
                textColor = Colors.neutral800;
                break;
            case 'peach':
                backgroundColor = Colors.peach;
                textColor = Colors.neutral800;
                break;
            case 'neutral300':
                backgroundColor = Colors.neutral300;
                textColor = Colors.neutral800;
                break;
            case 'bolt':
                backgroundColor = Colors.bolt;
                textColor = Colors.neutral800;
                break;
            case 'cream':
                backgroundColor = Colors.cream;
                textColor = Colors.neutral800;
                break;
            case 'success500':
                backgroundColor = Colors.success500;
                textColor = Colors.neutral100;
                break;
            case 'lavender':
                backgroundColor = Colors.lavender;
                textColor = Colors.neutral800;
                break;
        }
    }
    else {
        backgroundColor = Colors[color];
        const lightTextContrast = colord(backgroundColor).contrast(Colors.neutral100);
        const darkTextContrast = colord(backgroundColor).contrast(Colors.neutral800);
        if (lightTextContrast > darkTextContrast) {
            textColor = Colors.neutral100;
        }
        else {
            textColor = Colors.neutral800;
        }
    }
    return (isolateComponent("span", { css: Styles.root(backgroundColor, textColor), "data-size": size, className: className }, children));
};
//# sourceMappingURL=TagLabel.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
